import { useEffect, useState } from "react";
import axios from "axios";
import { listingLogs } from "../../../../../_metronic/helpers/utils";
import { convertUTCTimeToListingTime } from "../../../../../_metronic/helpers/convertTime";
import { Pagination } from "../../../../../components/Pagination";
import { toast } from "react-toastify";
import { UsersListLoading as Loading } from "../loading/UsersListLoading";
import { Link } from "react-router-dom";

const UserEditModalForm = ({
  setSelectedListingId,
  listing,
  openGateListModal,
  setOpenTimelineModal,
  amenities
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [admins, setAdmins] = useState([]);
  const [timeline, setTimeline] = useState([])
  const [showGateLogs, setShowGateLogs] = useState(openGateListModal);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);

  const cancel = () => {
    if (!openGateListModal) {
        setSelectedListingId(null)
    }
    setOpenTimelineModal(false);
  };


  const adminList = () => {
    axios.get(`${process.env.REACT_APP_API_URL}/admin/public`).then((res) => {
      setAdmins(res.data);
    });
  }


  useEffect(() => {
    adminList()
  }, [])


  const extractTitlesFromIds = (note) => {
    const amenityIds = note.match(/\d+/g);

    if (amenityIds) {
      return amenityIds.map(id => {
        const amenity = amenities.find(item => item.id === Number(id));
        return amenity ? amenity.title : `Unknown ID: ${id}`;
      });
    }
    return [];
  };

const extractBookingNumber = (note) => {
  const match = note.match(/#([A-Z0-9]+)/);
  return match ? match[1] : null;
};

const gateLogsList = () => {
  setIsLoading(true)
  axios.get(`${process.env.REACT_APP_API_URL}/gates/logs?listing_id=${listing.listing_id}&page=${page}&page_size=${pageSize}`)
  .then((res) => {
   
setTimeline(
  res.data.result
    .sort((a, b) => b.id - a.id)
    .map(item => {
      const bookingNumber = extractBookingNumber(item.notes);
      const bookingLink = bookingNumber 
        ? `<a href="/bookings?search_type=reservation_code&search=${bookingNumber}">#${bookingNumber}</a>` 
        : null;

      const updatedNotes = bookingNumber
        ? item.notes.replace(`#${bookingNumber}`, bookingLink)
        : item.notes;

      return {
        ...item,
        notes: updatedNotes
      };
    })
  );
  setTotal(res.data.total);
  }).catch(err => {
    if (err && err.response && err.response?.data && err.response?.data?.message) {
      toast.error(err.response.data.message)
    }
  }).finally(() => {
    setIsLoading(false)
  })
}

const getListingLogs = () => {
  setIsLoading(true)
  axios.get(`${process.env.REACT_APP_API_URL}/listing/${listing.listing_id}/timeline`)
  .then((res) => {
    setTimeline(res?.data?.sort((a, b) => b.id - a.id).filter(item => ![32, 33, 34].includes(item.action_id)));
    setTotal(res.data.total);
  }).catch(err => {
    if (err && err.response && err.response?.data && err.response?.data?.message) {
      toast.error(err.response.data.message)
    }
  }).finally(() => {
    setIsLoading(false)
  })
}

const onShowGateLogs = () => {
  if ( showGateLogs ) {
    gateLogsList()
  } else {
    getListingLogs()
  }
}


  useEffect(() => {
    onShowGateLogs()
  }, [showGateLogs, page, pageSize])


  const actionBy = (status, item) => {
      switch (status) {
        case 1:
          return item?.action_by_name ? `${item.action_by_name} (Trucker Member)` : 'Trucker Member'
        case 2:
          return item?.action_by_name ? `${item.action_by_name} (Property Owner)` : '(Property Owner)'
        case 3:
          return`${admins?.find((_i) => _i.id == item.action_by)?.name || ""} (Admin)`
        case 4:
          return 'Auto'
        case 5:
          return item?.action_by_name ? `${item.action_by_name} (Property Manager)` : 'Property Manager'
      }
  }



  return (
    <>
      <div className="kt_body">
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          {(listing?.gate_allowed && !openGateListModal) && <button className="btn btn-sm btn-info mb-4 mt-0 text-white" onClick={() => setShowGateLogs(!showGateLogs)}>{showGateLogs ? "Show Other Logs" : 'Show Gate Logs Only'}</button>}
        </div>
        <div className="mb-2" style={{ maxHeight: '300px', overflowY: 'auto', minHeight: 'auto' }}>
          {isLoading ? <Loading /> :
            !!timeline?.length ?
              <>
                {timeline.map((item, index) => {
                  return <div
                    key={index}
                    style={{ display: 'flex', gap: '5px', background: '#f9f9f9', marginBottom: '10px', padding: '10px', borderRadius: '10px', flexDirection: 'column' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <h4 style={{ marginBottom: '2px' }}> {listingLogs(item.action_id)}</h4>
                      <h6>{convertUTCTimeToListingTime(item.createdAt, listing.timezone_id, 0, "dddd, Do MMMM YYYY, hh:mm A")}</h6>
                    </div>
                    <h6 className="mb-1">Action Done By: {item.tm_uid ? <Link to={`/users/${item.tm_uid}`}>{actionBy(item.action_by_role, item)}</Link> : actionBy(item.action_by_role, item)}</h6>
                    {item.action_id === 10 && item.notes ? (
                      <div>
                        <h6>{item?.notes?.includes("Amenities added") ? "New Amenities Added" : "Amenities Removed"}</h6>
                        <ul>
                          {extractTitlesFromIds(item.notes)?.map((title, index) => (
                            <li key={index}>{title}</li>
                          ))}
                        </ul>
                      </div>
                    ) : (
                      item.action_id !== 10 && item.action_id !== 16 && item.action_id !== 17 && item.notes && (
                        <h6 dangerouslySetInnerHTML={{ __html: item.notes }}></h6>
                      )
                    )}

                  </div>
                })
                }
              </>
              :
              <h4 className="text-center">No Timeline yet for this listing</h4>
          }
        </div>
       {showGateLogs && <Pagination
        page={page}
        setPage={setPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        total={total}
        pageSizeOptions={[50, 75, 100]}
        />
       }
        <div style={{ display: "flex", gap: "10px" }}>
          <button
            type="button"
            className="btn mt-4 w-100 btn-primary"
            onClick={() => cancel()}
            style={{
              color: "#fff",
              height: "46px",
              fontWeight: "700",
            }}
          >
            Go Back
          </button>
        </div>
      </div>
    </>
  );
};

export { UserEditModalForm };
